export default "__VITE_ASSET__213f5f63__"